module.exports = __webpack_public_path__ + "img/icon10.7b9f8566.png";